
/**
 * `kioskApiPages`.
 */

const kioskApiPages = {
  kioskHome: 'kiosk-homepage'
};

/**
 * Export `en` api page routes.
 */

export const en = {
  ...kioskApiPages,
  aboutUs: 'about-us',
  aboutUsSgiPolicy: 'policy-of-the-integrated-management-system',
  careers: 'recruitment',
  certificates: 'certificates',
  collection: null,
  collections: 'collections',
  contacts: 'contacts',
  cookiesPolicy: 'cookies-policy',
  downloads: 'downloads',
  environment: 'environment',
  faq: null,
  faqs: 'faq',
  fundedProjects: 'funded-projects',
  highlights: 'highlights',
  history: 'history',
  home: 'homepage',
  innovation: 'innovation',
  inspiration: 'inspiration',
  inspirationDetails: 'inspiration-detail',
  lightXl: 'light-xl',
  media: 'media',
  portfolio: 'portfolio',
  portfolioDetails: 'portfolio-detail',
  privacyPolicy: 'privacy-policy',
  productContact: 'product-contact-us',
  productDetails: null,
  recommend: 'recommend',
  recommendResults: null,
  reportingChannel: 'reporting-channel',
  socialResponsability: 'social-accountability',
  storytiling: 'storytiling',
  storytilingDetails: 'storytiling-detail',
  tech20mm: 'tech-20mm',
  termsConditions: 'terms-and-conditions',
  toolsBimObjects: 'bim',
  toolsEnvironmentSimulator: 'environment-simulator',
  toolsProductComparator: 'comparator',
  whereToBuy: 'where-to-buy',
  whereToBuyResults: 'where-to-buy-results'
};
